import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import dayjs from "dayjs";
export default function TableCard({ item, callback }) {
  return (
    // <Card
    //   sx={{
    //     width: "96%",
    //     mt: "10px",
    //     cursor: "pointer",
    //     backgroundColor: "#E3E3FF",
    //     "& .MuiCardContent-root": { p: "0rem" },
    //     borderRadius: "9px",
    //     padding: "10px ",
    //     paddingLeft: "30px",
    //     boxShadow: "none",
    //   }}

    // >
    //   <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
    <Grid
      container
      sx={{
        p: "8px 0",
        borderBottom: "1px solid #eee",
        alignItems: "center",
        backgroundColor: "#E8E8FF",
        borderRadius: "8px",
        mb: 1,
        cursor: "pointer",
      }}
      onClick={() => {
        callback();
      }}
    >
      <Grid item xs={0} sm={0} md={1}></Grid>
      <Grid item xs={2}>
        <Typography
          color="primary"
          sx={{
            fontSize: { xs: "10px", sm: "13px", md: "15px" },
            // overflow: "Hidden",
            // display: "-webkit-box",
            // "-webkit-line-clamp": "1",
            // "-webkit-box-orient": "vertical",
            fontWeight: 500,
            color: "#000000",
            padding: "0px 10px",
            borderRadius: "10px",
            textAlign: "left",
          }}
        >
          {item?.name}
        </Typography>
      </Grid>

      <Grid item xs={3}>
        <Typography
          color="primary"
          sx={{
            fontSize: { xs: "10px", sm: "13px", md: "15px" },
            // overflow: "Hidden",
            // display: "-webkit-box",
            // "-webkit-line-clamp": "1",
            // "-webkit-box-orient": "vertical",
            fontWeight: 500,
            color: "#000000",
            marginRight: "25px",
            textAlign: "center",
            padding: "0px 10px",
            borderRadius: "10px",
          }}
        >
          {item?.customerMobile}
        </Typography>
      </Grid>

      <Grid item xs={3} sm={3} md={2}>
        <Typography
          color="primary"
          sx={{
            fontSize: { xs: "10px", sm: "13px", md: "15px" },
            // overflow: "Hidden",
            // display: "-webkit-box",
            // "-webkit-line-clamp": "1",
            // "-webkit-box-orient": "vertical",
            fontWeight: 500,
            color: "#000000",
            textAlign: "center",
            padding: "0px 0px",
            borderRadius: "10px",
          }}
        >
          {!!item?.birthdate
            ? dayjs(item?.birthdate).format("DD-MMM-YYYY")
            : "-"}
        </Typography>
      </Grid>

      <Grid item xs={3} sm={3} md={2}>
        <Typography
          color="primary"
          sx={{
            fontSize: { xs: "10px", sm: "13px", md: "15px" },
            // overflow: "Hidden",
            // display: "-webkit-box",
            // "-webkit-line-clamp": "1",
            // "-webkit-box-orient": "vertical",
            fontWeight: 500,
            color: "#000000",
            marginLeft: "0px",
            textAlign: "center",
            padding: "0px 0px",
            borderRadius: "10px",
          }}
        >
          {!!item?.anniversaryDate
            ? dayjs(item?.anniversaryDate).format("DD-MMM-YYYY")
            : "-"}
        </Typography>
      </Grid>
      <Grid item xs={0} sm={0} md={1}></Grid>
    </Grid>
    //     </CardContent>
    //   </Card>
  );
}
